import { Dependency } from '@tempo-io/sui-icons';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@tempo-io/sui-tooltip';
import { AlertDot } from '@/common/components/badges/AlertDot';

const DEPENDENCY_ICON = <Dependency className="size-4 text-icon-neutral-secondary" />;

interface DependencyIndicatorProps {
  isError: boolean;
  isWarning: boolean;
  tooltip: string;
  alertDotTestId: string;
}

export const DependencyIndicator = ({
  isError,
  isWarning,
  tooltip,
  alertDotTestId,
}: DependencyIndicatorProps) => {
  if (!isError && !isWarning) {
    return <span className="flex w-full items-center">{DEPENDENCY_ICON}</span>;
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            aria-label={tooltip}
            className="flex w-full cursor-default items-center"
          >
            <span className="relative inline-flex">
              {DEPENDENCY_ICON}
              <AlertDot variant={isError ? 'error' : 'warning'} data-testid={alertDotTestId} />
            </span>
          </button>
        </TooltipTrigger>
        <TooltipContent>{tooltip}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
